import React from 'react';

import { SkeletonButton, SkeletonText } from '@febos-io/design';

export function ExamReportSheleton() {
  return (
    <div className="row">
      <div className="col">
        <SkeletonText />
        <SkeletonText />
        <SkeletonText />
        <SkeletonText />
        <SkeletonText />
        <SkeletonButton />
      </div>
    </div>
  );
}

export default ExamReportSheleton;

ExamReportSheleton.propTypes = {};
